import { NgModule } from "@angular/core";
import { DocumentViewComponent } from "./document-view/document-view.component";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Document',
          },
        component: DocumentViewComponent,
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DocumentRountingModule { }